<template>
  <div>
    <Chart
      v-if="isChart"
      :resourceName="resourceName"
      :pk="pk"
      :productId="productId"
      :breadcrumbs="breadcrumbs"
    />
    <List 
      v-else-if="isList"
      :productId="productId"
      :breadcrumbs="breadcrumbs"
    />
  </div>
</template>

<script>
import Chart from '@/views/answers/answers-show-chart';
import List from '@/views/answers/answers-show-list';

export default {
  components: {
    Chart,
    List
  },
  props: {
    pk: {
      type: String,
      required: true
    },
    productId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      resourceName: "answers"
    };
  },
  computed: {
    entity() {
      return this.$store.getters[`${this.resourceName}/list/entity`];
    },
    answerMethod() {
      return this.entity.answer_method;
    },
    isChart() {
      return this.answerMethod === 2 || this.answerMethod === 3;
    },
    isList() {
      return this.answerMethod === 1;
    },
    loading() {
      return this.$store.getters[`${this.resourceName}/list/isLoading`];
    },
    loaded() {
      return this.$store.getters[`${this.resourceName}/list/isLoaded`];
    },
    breadcrumbs() {
      return [
        {
          text: "レビュー結果選択",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "レビュー質問一覧",
          disabled: false,
          to: `/${this.resourceName}/${this.productId}/${this.$route.params.questionId}`
        },
        {
          text: "レビュー回答確認",
          disabled: true
        }
      ];
    }
  },
  methods: {
  },
  mounted() {
    this.$store.dispatch(`${this.resourceName}/list/show`, {
      pk: this.pk,
      productId: this.productId
    });
  },
  watch: {
    loaded(value) {
      if (value && !Object.keys(this.entity).length) {
        // 存在しないIDなどの場合は一覧画面に遷移させる
        this.$router.push({path : `/${this.resourceName}`});
      }
    }
  }
};
</script>
